
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/repayments-calculator",
      function () {
        return require("private-next-pages/repayments-calculator/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/repayments-calculator"])
      });
    }
  